export default __webpack_public_path__ + "bab5929c3b554fa141e68f3cea35518c.pdf";